import { render, staticRenderFns } from "./PartnerFormDialog.vue?vue&type=template&id=220ecd0c&scoped=true&"
import script from "./PartnerFormDialog.vue?vue&type=script&lang=js&"
export * from "./PartnerFormDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "220ecd0c",
  null
  
)

export default component.exports